import { useSubscriptionsStore } from "@shared/stores/subscriptions";
import { type RequestCurationTrialRequest } from "@shared/types/common";
import { cookiesService } from "@shared/services/cookies";
import { subscriptionsService } from "@shared/services/subscriptions";
import { messagesService } from "@shared/services/messages";
import logger from "@shared/utils/logger.ts";
import { useNotifications } from "@shared/module-transformers/useNotifications.ts";
import { RequestTrialParams } from "@shared/types/localtypes.ts";

export const requestCurationTrial = async ({
  serverNameParam,
  accountNumberParam,
  isShParam,
}: RequestTrialParams = {}) => {
  try {
    const currentSubscription = useSubscriptionsStore().currentSubscription;

    if (!currentSubscription && !serverNameParam) {
      return;
    }

    const serverName =
      (currentSubscription &&
        currentSubscription.meta.isSaas &&
        subscriptionsService.extractMainSaasServer(currentSubscription)
          ?.serverName) ||
      serverNameParam ||
      null;

    const accountNumber = currentSubscription
      ? currentSubscription.accountNumber
      : accountNumberParam || 0;

    const isSh = currentSubscription
      ? currentSubscription.meta.isSelfHosted
      : isShParam;

    const request: RequestCurationTrialRequest = {
      marketoCookie: cookiesService.marketoCookie(),
      serverName,
      accountNumber,
      isSh,
    };

    await subscriptionsService.requestCurationTrial(request);
    useNotifications().success(messagesService.curation_trial_request_success);
  } catch (e) {
    logger.error(e);
    useNotifications().error(messagesService.app_something_went_wrong);
  }
};
